import React, { useState, useRef } from "react";
import { X } from "lucide-react";
import RegistrationForm from "./RegistrationForm";

function getModalType() {
  const { hostname, port } = window.location;
  const hostPort = `${hostname}:${port}`;
  if (hostname === "standup-comedy.ch" || hostPort === "localhost:3003")
    return "standup";
  if (hostname === "ragescream.com" || hostPort === "localhost:3001")
    return "rock";
  return null;
}

const RegistrationInviteModal = ({ open, onClose }) => {
  const modalType = getModalType();
  // Si pas de modalType, ne rien afficher
  if (!modalType) return null;
  if (!open) return null;
  const modalRef = useRef(null);


  // Fonction pour fermer la modal
  const handleClose = () => {
    if (onClose) onClose();
  };

  // Fermer la modal si on clique en dehors
  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      handleClose();
    }
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={handleBackdropClick}
    >
      <div
        ref={modalRef}
        className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
            onClick={handleClose}
          aria-label="Fermer la popup"
        >
          <X size={24} />
        </button>
        {modalType === "standup" ? (
          <>
            <h2 className="text-2xl font-bold mb-4 text-center text-black">
              Artistes, inscrivez votre chaîne YouTube !
            </h2>
            <p className="mb-6 text-gray-700 text-center">
              Vous êtes humoriste ou artiste ?<br />
              Hébergez votre playlist YouTube sur notre plateforme.
              <br />
              <span className="font-semibold text-blue-600">
                Contactez-nous pour mettre en avant vos vidéos.
              </span>
            </p>
              <RegistrationForm onClose={handleClose} />
          </>
        ) : (
          <>
            <h2 className="text-2xl font-bold mb-4 text-center text-black">
              Groupes Rock/Metal, inscrivez votre chaîne YouTube !
            </h2>
            <p className="mb-6 text-gray-700 text-center">
              Vous êtes un groupe rock ou metal ?<br />
              Hébergez votre chaîne ou playlist YouTube sur ragescream.com.
              <br />
              <span className="font-semibold text-red-600">
                Contactez-nous pour mettre en avant vos clips et albums.
              </span>
            </p>
              <RegistrationForm onClose={handleClose} />
          </>
        )}
      </div>
    </div>
  );
};

export default RegistrationInviteModal;
